// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pair-icons[data-v-6d696519]{position:relative}.pair-icons .pair-icon[data-v-6d696519]{border-radius:50%;-o-object-fit:cover;object-fit:cover;position:absolute}.pair-icons .icon-1[data-v-6d696519]{bottom:var(--offset);right:var(--offset)}.pair-icons .icon-2[data-v-6d696519]{left:var(--offset);top:var(--offset)}.pair-icons.row .icon-1[data-v-6d696519]{bottom:0}.pair-icons.row .icon-2[data-v-6d696519]{top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
